import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewDependencyDetails: {
		id: 'software.main.board-container.board.card-container.card.issue-links-indicator.view-dependency-details',
		defaultMessage: 'View dependency details',
		description: 'Tooltip around an icon indicating whether an issue has dependencies',
	},
});
